module.exports = __webpack_public_path__ + "static/media/sesame.d039a81e.svg";